var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      ref: "stickyNav",
      staticClass: "ns-sticky-nav js-ns-sticky-nav",
      class: {
        "no-cta": !_vm.ctaCopy,
        "show-shadow": _vm.message,
        "extra-padding": _vm.showExtraPadding
      },
      attrs: { id: "waypoint" }
    },
    [
      _c(
        "div",
        {
          staticClass: "ns-sticky-nav__container",
          class: { "open-drawer": _vm.drawerIsOpen }
        },
        [
          !_vm.message
            ? [
                _c("p", { staticClass: "ns-sticky-nav__page-title" }, [
                  _vm._v(_vm._s(_vm.pageTitle))
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "ns-sticky-nav__chevron js-toggle-sticky-drawer",
                    on: { click: _vm.toggleDrawer }
                  },
                  [
                    _c("iron-icon", {
                      attrs: { icon: "nuskin:icon-chevron-down" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "ns-sticky-nav__link-list" },
                  _vm._l(_vm.navigation, function(navItem) {
                    return _c(
                      "li",
                      {
                        key: navItem.name,
                        class: {
                          active:
                            _vm.activeLink && navItem.href === _vm.activeLink
                        }
                      },
                      [
                        _c("a", {
                          attrs: { href: "#" + navItem.href },
                          domProps: { innerHTML: _vm._s(navItem.title) },
                          on: { click: _vm.scrollToLink }
                        })
                      ]
                    )
                  }),
                  0
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.message || _vm.ctaCopy
            ? _c("div", { staticClass: "ns-sticky-nav__message-cta" }, [
                _vm.message
                  ? _c("div", { staticClass: "ns-sticky-nav__message" }, [
                      _vm._v("\n        " + _vm._s(_vm.message) + "\n      ")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.ctaCopy
                  ? _c(
                      "div",
                      {
                        staticClass: "ns-sticky-nav__cta",
                        class: { "ns-sticky-nav__cta--no-flex": _vm.message }
                      },
                      [
                        _c(
                          "ns-button",
                          {
                            attrs: {
                              href: _vm.ctaHref,
                              target: _vm.ctaOpenNewTab ? "_blank" : "_self",
                              theme: _vm.ctaAccent ? "primary-hit" : "primary",
                              size: _vm.ctaShort ? "short" : "adaptive-reverse"
                            }
                          },
                          [_vm._v(_vm._s(_vm.ctaCopy))]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ])
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }